import {addOpenDrawer} from "../store/actions/appAction";

export function openRemittanceDrawer(dispatch, remittance) {
    dispatch(addOpenDrawer(true, "remittanceDrawer", "left", {remittance, style: {width: "auto"}}));
}

export function openTransferDrawer(dispatch, transfer) {
    dispatch(addOpenDrawer(true, "transferDrawer", "left", {transfer, style: {width: "auto"}}));
}

export function openAccountingDrawer(dispatch, accounting) {
    dispatch(addOpenDrawer(true, "accountingDrawer", "left", {accounting, style: {width: "auto"}}));
}

export function openTransactionDrawer(dispatch, transaction) {
    dispatch(addOpenDrawer(true, "transactionDrawer", "left", {transaction, style: {width: "auto"}}));
}

export function openFactorDrawer(dispatch, factor) {
    dispatch(addOpenDrawer(true, "factorDrawer", "left", {factor, style: {width: "auto"}}));
}

export function openInstallmentDrawer(dispatch, installment) {
    dispatch(addOpenDrawer(true, "installmentDrawer", "left", {installment, style: {width: "auto"}}));
}

export function openChequeDrawer(dispatch, cheque) {
    dispatch(addOpenDrawer(true, "chequeDrawer", "left", {cheque, disableAction: true}));
}
